import { Component, OnInit } from '@angular/core';
import { CrudServiceService } from 'src/app/services/crudService/crud-service.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-prescription-list',
  templateUrl: './prescription-list.component.html',
  styleUrls: ['./prescription-list.component.scss']
})
export class PrescriptionListComponent implements OnInit {
  displayedColumns: string[] = ['treatment', 'prescribed_drugs', 'createdAt', 'status', 'action'];
  dataSource: any[] = [];
  departments: any[] = [];
  selectedDepartment: string = '';
  isLoading: boolean = false;
  searchInput: string = '';

  constructor(
    private crudService: CrudServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadDepartments();
  }

  loadDepartments() {
  this.isLoading = true;
  this.crudService.getAll(environment.api.department, {}).then((res: any) => {
    console.log("API Response:", res);
    
    if (res && res.data && Array.isArray(res.data)) {
      this.departments = res.data;      
      const dentistDept = this.departments.find(dept => 
        dept.name.toLowerCase().includes('dentist'));
      if (dentistDept) {
        this.selectedDepartment = dentistDept._id;
        this.onDepartmentChange(); 
      }
      
    } else {
      console.warn("Unexpected response format:", res);
      this.departments = [];
    }
    
    this.isLoading = false;
  }).catch(err => {
    console.error('Error loading departments:', err);
    this.isLoading = false;
    this.departments = [];
  });
}

  onDepartmentChange() {
    if (this.selectedDepartment) {
      this.loadPrescriptions();
    } else {
      this.dataSource = [];
    }
  }

  loadPrescriptions() {
    this.isLoading = true;
    this.crudService.getAll(`${environment.api.template}/all-prescriptions/${this.selectedDepartment}`, {}).then((res: any) => {
      this.dataSource = res.data;
      console.log("prescription",res)
      this.isLoading = false;
    }).catch(err => {
      console.error('Error loading prescriptions:', err);
      this.isLoading = false;
    });
  }

  editPrescription(id: string) {
    this.router.navigate(['admin/prescription/edit', id]);
  }

  deletePrescription(id: string) {
    if (confirm("Are you sure you want to delete this prescription template?")) {
      this.isLoading = true;
      this.crudService.delete(id, `${environment.api.template}/prescription`).then(() => {
        this.loadPrescriptions();
      }).catch(err => {
        console.error('Error deleting prescription:', err);
        this.isLoading = false;
      });
    }
  }

  addPrescription() {
    this.router.navigate(['admin/prescription/add']);
  }
}